module.exports = __webpack_public_path__ + "img/bad-2d-stairs.dfdd6f66.gif";